export class ApiError extends Error {
  constructor(
    message: string,
    public path: string,
    public status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
